import { all, fork, put, takeLatest } from "redux-saga/effects";
import { getQuery, postQuery, putQuery, deleteQuery } from "utils/api";
import { Toast } from "utils/toast";
import { actions } from "./action";
import { adminsFirst } from "./adminsFirst";

export function* createTutor() {
  yield takeLatest(
    actions.CREATE_TUTOR_REQUEST,
    function* ({ data, navigate }) {
      try {
        const response = yield postQuery(`tutor`, data);

        if (!response.data.error) {
          yield put({
            type: actions.CREATE_TUTOR_SUCCESS,
            payload: [response?.data?.result],
          });
          Toast("success", "Tutor Created Successfully!");
        }
      } catch (e) {
        console.error(e);
        yield put({
          type: actions.CATCH_ERROR,
          payload: true,
        });
        if (!e._isAuthError) Toast("error", e?.response?.data?.message);
      }
    }
  );
}

export function* updateTutor() {
  yield takeLatest(actions.UPDATE_TUTOR_REQUEST, function* ({ data, alert }) {
    try {
      const response = yield putQuery(`tutor`, data);
      if (!response.data.error) {
        if (data.get("role")) {
          yield put({
            type: actions.UPDATE_TUTOR_SUCCESS,
            payload: response?.data?.result,
          });
        }
        alert && Toast("success", "Tutor Updated Successfully!");

        if (
          (!alert && data?.isDelete === true) ||
          data.get("isDelete") === "true"
        ) {
          yield put({
            type: actions.REMOVE_TUTOR_SUCCESS,
            payload: response?.data?.result,
          });
        }
        if (
          (!alert && data?.isDelete === false) ||
          data.get("isDelete") === "false"
        ) {
          yield put({
            type: actions.UNREMOVE_TUTOR_SUCCESS,
            payload: response?.data?.result,
          });
        }
      }
    } catch (e) {
      console.error(e);
      yield put({
        type: actions.CATCH_ERROR,
        payload: true,
      });
      if (!e._isAuthError) Toast("error", e.response?.data?.message);
    }
  });
}

export function* deleteTutor() {
  yield takeLatest(
    actions.DELETE_TUTOR_REQUEST,
    function* ({ data, navigate }) {
      try {
        const response = yield deleteQuery(`tutor/remove?tutorId=${data}`);

        if (!response.data.error) {
          yield put({
            type: actions.DELETE_TUTOR_SUCCESS,
            payload: data,
          });
          Toast("success", "Tutor Deleted Successfully!");
        }
      } catch (e) {
        console.error(e);
        yield put({
          type: actions.CATCH_ERROR,
          payload: true,
        });
        if (!e._isAuthError) Toast("error", e.response?.data?.message);
      }
    }
  );
}

export function* getTutors() {
  yield takeLatest(actions.GET_TUTORS_REQUEST, function* ({ data, includeArchived }) {
    try {
      const query = new URLSearchParams();
      if (data) query.set("clubId", data);
      if (includeArchived) query.set("includeArchived", "true");
      const response = yield getQuery(`tutor?${query}`);
      if (!response?.data?.error) {
        yield put({
          type: actions.GET_TUTORS_SUCCESS,
          payload: adminsFirst(response?.data?.result || []),
        });
      }
    } catch (e) {
      console.error(e);
    }
  });
}

export function* getClubAdmins() {
  yield takeLatest(actions.GET_CLUB_ADMINS_REQUEST, function* ({ data }) {
    try {
      const response = yield getQuery(`clubAdmin`);
      if (!response?.data?.error) {
        yield put({
          type: actions.GET_CLUB_ADMINS_SUCCESS,
          payload: response?.data?.result,
        });
      }
    } catch (e) {
      console.error(e);
    }
  });
}

export function* clearTutorsState() {
  yield takeLatest(actions.CLEAR_TUTORS_STATE_REQUEST, function* () {
    try {
      yield put({
        type: actions.CLEAR_TUTORS_STATE_SUCCESS,
        payload: [],
      });
    } catch (e) {
      console.error(e);
    }
  });
}

export default function* tutorSaga() {
  yield all([
    fork(createTutor),
    fork(getTutors),
    fork(updateTutor),
    fork(getClubAdmins),
    fork(deleteTutor),
    fork(clearTutorsState),
  ]);
}
